import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/autoplay'
import { Autoplay, Grid, Navigation } from 'swiper/modules';

import JobCategoryCard from "./JobCategoryCard";

const CategoryCarousel = ({ categories, prevID, nextID }) => {
  // Split categories into chunks of 8 (4 items per row, 2 rows)
  const chunkedCategories = [];
  for (let i = 0; i < categories.length; i += 8) {
    chunkedCategories.push(categories.slice(i, i + 8));
  }

  return (
    <Swiper
      spaceBetween={10}
      // autoplay={{
      //   delay: 2000,
      //   disableOnInteraction: false,
      // }}
      breakpoints={{
        0: {
          slidesPerView: 1,
          grid: { rows: 1, fill: 'row' }
        },
        640: {
          slidesPerView: 2,
          grid: { rows: 1, fill: 'row' }
        },
        768: {
          slidesPerView: 2,
          grid: { rows: 2, fill: 'row' }
        },
        1024: {
          slidesPerView: 4,
          grid: { rows: 2, fill: 'row' }
        },
      }}
      navigation={{
        prevEl: `#${prevID}`,
        nextEl: `#${nextID}`
      }}
      modules={[Grid, Navigation, Autoplay]}
      className="w-full h-full"
    >
      {categories.map((category, index) => (
        <SwiperSlide  key={index}>
          <JobCategoryCard
            key={index}
            id={category.Code}
            icon={category.Char1}
            title={category.Name}
            countJob={category.CountJob}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CategoryCarousel;
